import axios, { AxiosError } from 'axios';
import { useQuery } from 'react-query';

const useRequest = <T extends { data: Record<string, any> }>(
  url: string,
  queryKey: string,
  shouldQuery: boolean,
  page?: number,
) => {
  const { data, isLoading, error, refetch } = useQuery<T, AxiosError>(
    [queryKey, page],
    () =>
      axios
        .request<T>({ method: 'GET', url })
        .then((response) => response.data),
    {
      enabled: shouldQuery,
      staleTime: 5 * 60 * 1000, // cache is fresh for 5 min — no refetch on back navigation
      retry: 1,
    },
  );

  return {
    data: data?.data,
    isLoading,
    error: error ?? undefined,
    refetch,
  };
};

export default useRequest;
